import './styles.scss';

import { ComboBox } from 'src/components/ui/combobox';
import { getI18n } from 'react-i18next';
import { PaymentHisotryTableData } from 'src/services/models/payment.service';
import { PaymentsService } from 'src/services/payments.service';
import { PaymentTypeFilter } from 'src/utils/enums/payment.enum';
import { useLocalization } from 'src/utils/useLocalization';
import { compareNumbers, compareStrings } from 'src/utils/helpers';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
interface ISearchProps {
    updateTableContent: Dispatch<SetStateAction<PaymentHisotryTableData[]>>;
    dealerID: string;
    setLoading: Dispatch<SetStateAction<boolean>>;
    sortType: string;
    sortOrder: boolean;
}

export const Search: React.FC<ISearchProps> = ({
    updateTableContent,
    dealerID,
    setLoading,
    sortType,
    sortOrder,
}) => {
    const {
        paymentHistory,
        //paymentTypeFilterEnumToUi,
        paymentTypeFilterUiToEnum,
        //paymentDateFilterEnumToUi,
        paymentDateFilterUiToEnum,
        //paymenStatusFilterEnumToUi,
        paymentStatusUiToEnum,
    } = useLocalization();
    const typeFilterOptions: string[] = [
        paymentHistory.SEARCH_PANDP,
        paymentHistory.SEARCH_PAYMENT,
        paymentHistory.SEARCH_PAYOFF,
    ];

    const dateFilterOptions: string[] = [
        paymentHistory.SEARCH_MONTH,
        paymentHistory.SEARCH_2MONTH,
        paymentHistory.SEARCH_3MONTH,
    ];

    const statusFilterOptions: string[] = [
        paymentHistory.SEARCH_ALL,
        paymentHistory.SEARCH_DELETED,
        paymentHistory.SEARCH_EXPIRED,
        paymentHistory.SEARCH_SUBMITTED,
    ];

    const [typeFilter, setTypeFilter] = useState<string>(typeFilterOptions[0]);
    const [statusFilter, setStatusFilter] = useState<string>(
        statusFilterOptions[0],
    );
    const [dateFilter, setDateFilter] = useState<string>(dateFilterOptions[2]);
    const [paymentHistoryData, setPaymentHistoryData] = useState<any[]>([]);

    const service = new PaymentsService();

    enum FilterNames {
        Type = 'Type',
        Status = 'Status',
        Date = 'Date',
    }

    const resetFilters = async (filtersToReset: FilterNames[]) => {
        const all = !filtersToReset.length;
        (!!all || !!filtersToReset.includes(FilterNames.Type)) &&
            setTypeFilter(typeFilterOptions[0]);
        (!!all || !!filtersToReset.includes(FilterNames.Status)) &&
            setStatusFilter(statusFilterOptions[0]);
        (!!all || !!filtersToReset.includes(FilterNames.Date)) &&
            setDateFilter(dateFilterOptions[2]);
    };

    const handleReset = async () => {
        await resetFilters([]);
    };

    const searchData = async () => {
        try {
            const response = await service.paymentHistory(dealerID);
            if (!!response && !!response.data) {
                const formattedResponse = service.mapResponse(response.data);
                setPaymentHistoryData(formattedResponse);
            }
        } catch {
            setPaymentHistoryData([]);
            setLoading(false);
        }
    };

    /**
     * Function to apply sort based on sort type and sor order
     * @param data
     * @returns
     */
    const applySort = (data: any[]) => {
        let sorted = [...data];
        switch (sortType) {
            case 'processDate':
                sorted = compareNumbers(sorted, 'processDate', sortOrder);
                break;
            case 'account':
                sorted = compareStrings(sorted, 'account', sortOrder);
                break;
            case 'amount':
                sorted = compareNumbers(sorted, 'amount', sortOrder);
                break;
            default:
                break;
        }
        return sorted;
    };

    const filterPaymentHistoryData = () => {
        let filteredData = [...paymentHistoryData];
        if (
            paymentTypeFilterUiToEnum[typeFilter] !=
            PaymentTypeFilter.PaymentPayOff
        ) {
            filteredData = filteredData.filter(
                (payment) =>
                    payment.paymentType ==
                    paymentTypeFilterUiToEnum[typeFilter],
            );
        }
        if (paymentStatusUiToEnum[statusFilter] != undefined) {
            filteredData = filteredData.filter(
                (payment) =>
                    payment.paymentStatus ==
                    paymentStatusUiToEnum[statusFilter],
            );
        }
        const today = new Date();
        const dateLimit = new Date(
            today.setMonth(
                today.getMonth() -
                    Number(paymentDateFilterUiToEnum[dateFilter]),
            ),
        );
        filteredData = filteredData.filter(
            (payment: PaymentHisotryTableData) =>
                payment.processDate >= dateLimit,
        );

        return applySort(filteredData);
    };

    useEffect(() => {
        searchData();
    }, []);

    useEffect(() => {
        updateTableContent(filterPaymentHistoryData());
    }, [paymentHistoryData]);

    useEffect(() => {
        if (paymentHistoryData.length > Number('0')) {
            updateTableContent(filterPaymentHistoryData());
        }
    }, [typeFilter, dateFilter, statusFilter, sortOrder, sortType]);

    useEffect(() => {
        resetFilters([]);
    }, [getI18n().language]);

    return (
        <div className='payments-search-bar search-row c-input'>
            <div className='select-ph-type'>
                <ComboBox
                    name={'type'}
                    options={typeFilterOptions}
                    defaultValue={typeFilterOptions[0]}
                    placeholder=''
                    onSelect={setTypeFilter}
                    selectedOption={typeFilter}
                />
            </div>
            <div className='select-ph-date'>
                <ComboBox
                    name={'date'}
                    options={dateFilterOptions}
                    defaultValue={dateFilterOptions[2]}
                    placeholder=''
                    onSelect={setDateFilter}
                    selectedOption={dateFilter}
                />
            </div>
            <div className='select-ph-status'>
                <ComboBox
                    name={'status'}
                    options={statusFilterOptions}
                    defaultValue={statusFilterOptions[0]}
                    placeholder=''
                    selectedOption={`${statusFilter}`}
                    onSelect={setStatusFilter}
                />
            </div>
            <div className='reset-ph-search'>
                <button
                    className={'c-btn--secondary c-btn c-btn--small'}
                    type={'button'}
                    onClick={handleReset}
                >
                    <span className='c-btn__text'>
                        {paymentHistory.SEARCH_RESET}
                    </span>
                </button>
            </div>
        </div>
    );
};

export default Search;
